import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';

@Component({
    selector: 'app-read-access-granted-dialog',
    templateUrl: './read-access-granted-dialog.component.html',
    styleUrls: ['./read-access-granted-dialog.component.scss'],
    standalone: false
})
export class ReadAccessGrantedDialogComponent implements OnInit {
    constructor(
		public dialogRef: DialogRef,
    ) {}

    ngOnInit(): void {
    }


    onClose() {
        this.dialogRef.close();
    }
}